// This file is auto-generated

import deCH from './jelmolich/de-CH.json';
import frCH from './jelmolich/fr-CH.json';

const messages = { 'de-CH': deCH, 'fr-CH': frCH };

export default messages;
